module.exports = "<div id=editShow> <h4>请修改</h4> <input id=inputHide type=password value={{value}}> <button id=save>确定</button> <button id=cancel>取消</button> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/encrypt-input-control/add-enrypt.html
// module id = 1147
// module chunks = 50